/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import FornitoriDetails from '../../userAuth/components/fornitori/fornitoriDetails'

function Fornitori({ regione, flag, flag2, onChiudi, dettagliIsOpen }) {
    const details = { display: 'grid', gridTemplateColumns: '0.25fr .5fr', gap: '5px' }

    const [fornitori, setFornitori] = useState([])
    const [fornitore, setFornitore] = useState({})
    const [msg, setMsg] = useState({ evtInCorso: null })
    const descrizione = useRef()

    async function getFornitori(a) {
        const res = await axios.get(`/getFornitori`)
        setFornitori(res.data)
    }
    function dettagliFnt(id) {
        setFornitore(fornitori.find(item => item.id === id))
        setMsg({ ...msg, dettagliPrevious: true })
        dettagliIsOpen('secondoFornitori')
    }
    useEffect(() => {
        if (flag === 'primoFornitori') { getFornitori(regione) }
    }, [flag])

    useEffect(() => { descrizione.current.innerHTML = fornitore.descrizione }, [fornitore])
    return (<>
        <div className={`divNotifiche${flag === 'primoFornitori' || flag2 === 'secondoFornitori' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={onChiudi}>◀
            </button><hr />
            <p className='mt-3 p-1 text-center'><b>Fornitori</b></p>
            <div style={{ overflowY: 'auto', height: '80%' }}>
                {fornitori.length !== 0 &&
                    fornitori.map(x => {
                        return (
                            <p style={{ cursor: 'pointer', backgroundColor: 'lightgrey', padding: '5px' }} key={x.id}
                                onClick={() => { dettagliFnt(x.id) }}
                            >
                                {x.genere} - <i style={{ color: 'green' }}>{x.regione}</i>
                            </p>
                        )
                    })
                }
                {fornitori.length === 0 && <p className='text-center'>Nessun fornitore disponibile</p>}
            </div>
        </div>

        {/* -------------------     BANNER DETTAGLI ------------------ */}
        <div className={`divNotifiche${flag2 === 'secondoFornitori' || flag === 'fornitoriDetails' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => {
                    setMsg({ evtInCorso: null }); onChiudi()
                }}>◀
            </button><hr />
            {fornitore &&
                <div style={{ marginBottom: '1rem', overflowY: 'scroll', height: '85%' }}>
                    <div>
                        {fornitore.img ?
                            <img src={`https://leuro-bucket.s3.amazonaws.com/${fornitore.img.split(',')[0]}`} alt=''
                                style={{ maxWidth: '80%', maxHeight: '250px', marginTop: '2em', border: '1px solid lightgrey', borderRadius: '10px' }} />
                            : <img src={require('../image/icons8-impostazioni-amministratore-maschio-32.png')} alt='' />
                        }
                    </div>
                    <h5 className='mt-3' style={{ fontFamily: 'Times New Roman', color: 'navy' }}>{fornitore.gruppo}</h5>
                    <b style={{ color: 'navy' }}>{fornitore.genere}</b>
                    <div style={details} className='mt-3'>
                        <div>Regione:</div><div><b>{fornitore.regione}</b></div>
                        <div>Città:</div><div><b> {fornitore.città}</b></div>
                    </div>

                    <div style={details} className='mt-3'>
                        <div><img src={require('../image/icons8-nuovo-messaggio-48.png')} width='25rem' alt='' /></div><div>{fornitore.emailUser}</div>
                    </div>
                    {fornitore.telefono !== '' &&
                        <div style={details} className='mt-2'>
                            <div><img src={require('../image/icons8-telefono-cellulare-48.png')} width='25rem' alt='' /></div><div><b>{fornitore.telefono}</b></div>
                        </div>
                    }
                    <div className='textAreaEventi' style={{ borderTop: '1px solid grey' }} ref={descrizione}></div>

                    {fornitore.img && fornitore.img.split(',')[0] !== '' &&
                        <div style={{ margin: '1em auto' }} className='row'>
                            {fornitore.img.split(',').map((elem, index) => {
                                return (
                                    <div key={index} className="mt-3">
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} alt=''
                                            style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'cover' }} className='rounded' />
                                    </div>
                                )
                            })}
                        </div>
                    }
                    <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                        <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                        {fornitore.url &&
                            <div className='btn btn-warning'>
                                <a href={fornitore.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                            </div>
                        }
                        {fornitore.fb &&
                            <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                <a href={fornitore.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank' rel="noreferrer"><b>f</b></a>
                            </span>
                        }
                        {fornitore.youtube &&
                            <span style={{ backgroundColor: 'red', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                <a href={fornitore.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank' rel="noreferrer"><b>▷</b></a>
                            </span>
                        }
                        {!fornitore.url && !fornitore.fb && !fornitore.youtube &&
                            <div>Nessun link presente </div>
                        }
                    </div>

                    <div className='mt-5'>
                        <button className='btn btn-secondary' onClick={onChiudi}>Indietro</button>
                        <button className='btn btn-primary ms-3' onClick={() => { dettagliIsOpen('fornitoriDetails') }}>Dettagli</button>
                    </div>
                </div>
            }
            {fornitore.id && <FornitoriDetails fornitore={fornitore} flag2={flag} />}
            <br /><br />
        </div>
    </>)
}
export default Fornitori